import { Box, Link, List, ListItem } from '@mui/material';
import classNames from 'classnames';
import { MouseEvent, ReactNode } from 'react';

import { useSxStyles } from './useStyles';

export type LegacyModuleIconTabProps = {
  tabId: number;
  icon: JSX.Element;
  href: string;
  label: string;
  disabled?: boolean;
  active?: boolean;
  shown?: boolean;
};

type PropsType = {
  tabs: LegacyModuleIconTabProps[];
  children?: ReactNode;
  onTabChange?: (tabId: number) => void;
};

export const LegacyModuleIconTabs = (props: PropsType) => {
  const { tabs, children, onTabChange } = props;
  const sxStyles = useSxStyles();

  const handleClick = (
    e: MouseEvent<HTMLElement>,
    tabId: number | undefined,
  ) => {
    if (onTabChange && tabId) {
      e.preventDefault();
      onTabChange(tabId);
    }
  };

  const renderTabs = (tabs: LegacyModuleIconTabProps[]) => {
    return tabs
      .filter((props) => !!props.shown)
      .map((props, index) => {
        const { icon, href, disabled, active, tabId, label } = props;

        return (
          <ListItem
            key={`search-tab-item-${index}`}
            title={label}
            sx={{ ...sxStyles.tab, ...(!!href ? sxStyles.tabButton : {}) }}
          >
            <Link
              className={classNames(!!active && 'active')}
              sx={{
                ...sxStyles.tabLink,
                ...(!!href ? sxStyles.tabLinkButton : {}),
              }}
              key={`search-tab-link-${index}`}
              href={href}
              aria-disabled={disabled}
              onClick={(e) => handleClick(e, tabId)}
            >
              {icon}
            </Link>
          </ListItem>
        );
      });
  };

  return (
    <>
      <List sx={sxStyles.tabs}>{renderTabs(tabs)}</List>
      <Box sx={sxStyles.content}>{children}</Box>
    </>
  );
};
